import { reactive, toRefs, getCurrentInstance } from "@vue/composition-api";

import _ from "lodash";
//@ts-ignore
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

type TState = {
  isLoading: Boolean;
  isError: Boolean;
  errorCode: String;
  errorMessage: String;
  data: any;
  totalCount: number;
};
interface IOptions {
  takeRawData?: boolean;
  validateFunction?: () => Promise<{ success: boolean }>;
  showLoading?: boolean;
  loadingMessage?: string;
  params?: { value: any };
  disableShowToastResCondition?: (params: { code: string; message: string }) => Boolean;
  disableSuccessMessage?: boolean;
  successMessage?: string;
  defaultData?: {} | [];
  nextFunction?: (data: any) => void;
  afterErrorFunction?: () => void;
  afterErrorOrTimeoutFunction?: {
    func: () => void;
    sec?: number;
  };
  afterTimeOutNextFunction?: {
    func: () => void;
    sec: number;
  };
}
type Options = IOptions & {};
export const useFetch = (fetchDataRoot, options: Options = {}) => {
  /*   if (getCurrentInstance() === null) throw "Not using this hook inside function"; */
  const vm = getCurrentInstance()?.proxy as any;
  if (!vm) throw "Not using this hook inside function";
  const state = reactive<TState>({
    isLoading: false,
    isError: false,
    errorCode: "",
    errorMessage: "",
    data: options.defaultData || null,
    totalCount: 0,
  });

  const { isLoading, isError, errorMessage, data, totalCount, errorCode } = toRefs(state);

  const fetchData = async (directParams?) => {
    let id = null;

    if (options.showLoading) {
      id = vm.$toast({
        component: ToastificationContent,
        props: {
          title: options.loadingMessage ? vm.$t(options.loadingMessage) : "Đang lưu...",
          icon: "loading",
          variant: "secondary",
        },
      });
    }

    isLoading.value = true;
    try {
      const res = await fetchDataRoot(directParams || options.params?.value);
      isLoading.value = false;
      vm.$toast.dismiss(id);
      if (res.Status !== "200") {
        console.log(options.afterErrorOrTimeoutFunction, "run 811");
        if (options.afterErrorOrTimeoutFunction) {
          const { func, sec } = options.afterErrorOrTimeoutFunction;

          setTimeout(() => {
            func();
          }, sec || 500);
        }
        if (options.afterErrorFunction) {
          options.afterErrorFunction();
        }
        const code = res.Messages[0]?.Code;
        const message = res.Messages[0]?.MessageText;
        errorCode.value = code;
        errorMessage.value = message;
        isError.value = true;

        if (
          !(
            options.disableShowToastResCondition &&
            options.disableShowToastResCondition({ code, message })
          )
        ) {
          vm.showResToast(res);
        }

        return;
      }
      isError.value = false;

      if (id !== null && !options.disableSuccessMessage) {
        vm.$toast({
          component: ToastificationContent,
          props: {
            title: vm.$t(options.successMessage) || "Thành công",
            icon: "ezAr-icon-check",
            variant: "success",
          },
        });
      }

      if (options.nextFunction) {
        options.nextFunction(res.Data);
      }
      if (options.afterErrorOrTimeoutFunction) {
        const { func, sec } = options.afterErrorOrTimeoutFunction;

        setTimeout(() => {
          func();
        }, sec || 500);
      }
      if (options.afterTimeOutNextFunction) {
        const { func, sec } = options.afterTimeOutNextFunction;

        _.debounce(func, sec || 500);
      }

      if (res.Data) {
        const keyConverted = Object.keys(res.Data);

        const isTableData = keyConverted.includes("TotalCount");

        if (isTableData) {
          totalCount.value = res.Data.TotalCount;
          let tempData: any[] = [];
          const dataValues = Object.values(res.Data);
          dataValues.forEach((item) => {
            if (Array.isArray(item)) {
              tempData = item;
            }
          });

          if (options.takeRawData) {
            data.value = res.Data;
            return res.Data;
          }
          data.value = tempData;
          return tempData;
        } else {
          data.value = res.Data;
          return res.Data;
        }
      }

      return res;
    } catch (err) {
      // @ts-ignore
      vm.showToast("error", err.message);
    }
  };

  return {
    isError,
    errorCode,
    isLoading,
    errorMessage,
    data,
    totalCount,
    fetchData,
  };
};
